import styled from '@emotion/styled'
import { colors } from '@core/Settings'

export const MysteryBetInvestmentStyled = styled('div')({
  backgroundColor: colors.quickbet.header.background,
  color: colors.quickbet.header.text,
  marginTop: '1rem',
  position: 'relative',
})
